import { useSidebar } from "@/context/SidebarContext";
import style from "./footer.module.scss";
import clsx from "clsx";
import { useSelector } from "react-redux";

const Footer = () => {
    const { isSidebarOpen } = useSidebar();
    const {languageData} = useSelector((state)=> state.language)

    return (
        <footer className={clsx(style.footer, isSidebarOpen && style.sidebar_close, "site_footer")}>
            <p>
                {/* Copyright © <time> {new Date().getFullYear()} </time> CasinoStars. All rights reserved. */}
                {languageData?.text?.footer?.copyright}
            </p>
        </footer>
    );
};

export default Footer;
